let order_review = require( './order-review' );

let payment_form = ( function( $ ) {

	let $payment_forms;

	let _init = function() {
		$payment_forms = $( '#payment-forms' );

		if ( $payment_forms.length > 0 ) {
			// When toggling type we also need to do this

			$( '#field_1_7' ).on( 'change', _on_billing_country_change );
			$( '#field_2_7' ).on( 'change', _on_billing_country_change );
		}
	};

	let on_form_switch = function( form_id ) {
		let $billing_country_field = $( '#field_' + form_id + '_7' );

		if ( $billing_country_field.length > 0 ) {
			var optionSelected = $billing_country_field.find( "option:selected" );
			var valueSelected  = optionSelected.val();

			_update_billing_country_ajax( valueSelected );
		}
	};

	let _on_billing_country_change = function( e ) {
		var optionSelected = $( this ).find( "option:selected" );
		var valueSelected  = optionSelected.val();

		_update_billing_country_ajax( valueSelected );
	};

	let _update_billing_country_ajax = function( country ) {
		let data = {
			country: country,
			action: 'crate_updated_billing_country',
			nonce: ScriptData.crate_updated_billing_country_nonce
		};

		$.post( ScriptData.ajaxurl, data, _update_billing_country_ajax_res );
	};

	let _update_billing_country_ajax_res = function( res ) {
		if ( res.success ) {
			order_review.update_order_review_html();
		} else {
			// Try again?
		}
	};

	$( document ).ready( _init );

	return {
		on_form_switch: on_form_switch
	};

} )( jQuery );

module.exports = payment_form;